import {UPDATE_PARTICIPANTS_LIST} from '../mutationTypes';

export default {
  [UPDATE_PARTICIPANTS_LIST](state, data) {
    state.participantsList = data.data;
  },
};
